import React from 'react';
import { style } from './styles'; // Adjust the path if necessary

const Table = ({ requests }) => {
  return (
    <div className="relative overflow-x-auto p-2 px-1 mt-10">
      <table className="table-auto border-collapse w-full">
        <thead>
          <tr className="border border-gray-800 border-opacity-50 text-xl font-bold" style={style.interText}>
            <th className="py-4">Date</th>
            <th className="py-4">Post Code</th>
            <th className="py-4">Name</th>
            <th className="py-4">Service Type</th>
            <th className="py-4">Email</th>
            <th className="py-4">Amount</th>
          </tr>
        </thead>
        <tbody>
          {requests.map((request, index) => (
            <tr key={index} className='text-lg font-normal border-b-2 border-gray-400 relative' style={style.interText}>
              <td className="px-4 py-4 pt-10">{request.date}</td>
              <td className="px-4 py-4 pt-10">{request.postcode}</td>
              <td className="px-4 py-4 pt-10">{request.name}</td>
              <td className="px-4 py-4 pt-10">{request.serviceType}</td>
              <td className="px-4 py-4 pt-10">{request.email}</td>
              <td className="px-4 py-4 pt-10">{request.amount}</td> {/* Display the fetched amount */}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;